import * as React from "react"
import {useEffect} from "react"
import {NumberFieldSeeker} from "@ui-seeker/core";

import {useRepricingFormData} from "../../@hooks";
import {disabledRepricing, repricingFormErrors} from "../../../@signals";


export default function RepricingFormActionValue() {
	const { actionValue, isPercentageChangeType, isMatchActionType, handleChangeValue } = useRepricingFormData()

	if (!!disabledRepricing.value)
		return <></>

    return <NumberFieldSeeker
		error={repricingFormErrors.value.actionValue}
		label={!isPercentageChangeType ? 'Amount' : 'Percentage'}
		disabled={isMatchActionType}
		value={actionValue}
		endIcon={!isPercentageChangeType ? 'coins' : 'percent'}
		onChange={e => handleChangeValue('actionValue', e.target.value)}
	/>
}